function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Dashboard = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "DashboardIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M6 21a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2H6z",
      opacity: ".8"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M21 19a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h1.535A3.998 3.998 0 0 1 8 17h8c1.48 0 2.773.804 3.465 2H21zM17 9h2v6h-2V9zm-4-2h2v8h-2V7zm-4 3h2v5H9v-5zm-4 2h2v3H5v-3z",
      clipRule: "evenodd"
    })]
  }));
});
Dashboard.displayName = 'DashboardIcon';
export default Dashboard;